import { render, staticRenderFns } from "./DynamicCharts.vue?vue&type=template&id=485bc9cc&"
import script from "./DynamicCharts.vue?vue&type=script&lang=js&"
export * from "./DynamicCharts.vue?vue&type=script&lang=js&"
import style0 from "./DynamicCharts.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports